import { FAQItemProps } from "@molecules/faq-item";
import { FAQTemplate } from "@templates/faq";
import {
  BlogArticleTranslationEntity,
  FAQTranslation,
  getDirectusInstance,
  resolveTranslation,
} from "@fhlib/directus";
import { GetServerSideProps, NextPage } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { BlogListTemplate } from "@templates/blog";
import { BlogListArticleProps } from "@organisms/blog-list-article";
import Head from "next/head";
import { useTranslation } from "next-i18next";

export type BlogProps = {
  articles: BlogListArticleProps[];
};

const BlogPage: NextPage<BlogProps> = ({ articles }) => {
  const { t } = useTranslation("blog");

  return (
    <>
      <Head>
        <title>{t("title")} - FeelingHome</title>
      </Head>
      <BlogListTemplate articles={articles} />
    </>
  );
};

export const getServerSideProps: GetServerSideProps<BlogProps> = async ({
  defaultLocale,
  locale,
}) => {
  const directus = await getDirectusInstance();
  const articlesService = directus.items("blog_articles");
  const articlesResponse = await articlesService.readByQuery({
    limit: -1,
    fields: ["cover", "translations.*"] as any,
    filter: { status: "published" },
  });
  const articles =
    articlesResponse.data?.map<BlogListArticleProps>((f) => {
      const tmp = resolveTranslation(
        locale,
        defaultLocale,
        f.translations as BlogArticleTranslationEntity[]
      );
      return {
        title: tmp.title,
        content: tmp.content,
        slug: tmp.slug,
        cover: f.cover as string,
      };
    }) ?? [];

  return {
    props: {
      ...(await serverSideTranslations(locale ?? "en", ["common", "blog"])),
      articles,
    },
  };
};

export default BlogPage;
